/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
import { ProjectForm } from '@/models/project';
import { getProjectDetail, getProgressDetail } from '@/configs/api-path';
import { ProgressDetail } from '@/models/progress';

@Component
export default class CheckProjectMixin extends Vue {
  checkProjectExist(projectId: number | string, enabled = false) {
    return new Promise((resolve, reject) => {
      if (!projectId) {
        reject(new Error('Please enter the project id'));
      }

      this.$axios.get<{
        code: number;
        project: ProjectForm;
      }>(getProjectDetail(projectId))
        .then(({ data: response }) => {
          if (response.code === 0) {
            if (enabled === true) {
              if (response.project.status === true) {
                resolve({
                  id: response.project.id,
                  name: response.project.name,
                  status: response.project.status,
                });
              }
              reject(new Error('此建案尚未啟用'));
            }
            resolve({
              id: response.project.id,
              name: response.project.name,
              status: response.project.status,
            });
          }
          reject(new Error('無法取得此建案'));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  checkProjectExistII<T>(projectId: number | string, enabled = false): Promise<{
    code: number;
    project?: any;
    message?: any;
  }> {
    return new Promise((resolve, reject) => {
      if (!projectId) {
        reject(new Error('Please enter the project id'));
      }

      this.$axios.get<{
        code: number;
        project: ProjectForm;
      }>(getProjectDetail(projectId))
        .then(({ data: response }) => {
          if (response.code === 0) {
            if (enabled === true) {
              if (response.project.status === true) {
                resolve({
                  code: 0,
                  project: {
                    id: response.project.id,
                    name: response.project.name,
                    status: response.project.status,
                  },
                });
              }
              resolve({
                code: 4,
                message: '此建案尚未啟用',
                project: {
                  id: response.project.id,
                  name: response.project.name,
                  status: response.project.status,
                },
              });
              // reject(new Error('此建案尚未啟用'));
            }
            resolve({
              code: 0,
              project: {
                id: response.project.id,
                name: response.project.name,
                status: response.project.status,
              },
            });
          }
          resolve({
            code: 101,
            message: '無法取得此建案',
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  checkProgressExist<T>(progressId: number | string): Promise<{
    code: number;
    progress?: any;
    message?: any;
  }> {
    return new Promise((resolve, reject) => {
      if (!progressId) {
        reject(new Error('Please enter the progress id'));
      }

      this.$axios.get<{
        code: number;
        progress: ProgressDetail;
      }>(getProgressDetail(progressId))
        .then(({ data: response }) => {
          if (response.code === 0) {
            // if (enabled === true) {
            //   if (response.progress.status === true) {
            //     resolve({
            //       code: 0,
            //       project: {
            //         id: response.project.id,
            //         name: response.project.name,
            //         status: response.project.status,
            //       },
            //     });
            //   }
            //   resolve({
            //     code: 4,
            //     message: '此建案尚未啟用',
            //     project: {
            //       id: response.project.id,
            //       name: response.project.name,
            //       status: response.project.status,
            //     },
            //   });
            //   // reject(new Error('此建案尚未啟用'));
            // }
            resolve({
              code: 0,
              progress: {
                id: progressId,
                title: response.progress.title,
                note: response.progress.note,
                publish_time: response.progress.publish_time,
                is_send: response.progress.is_send,
                message: response.progress.message,
              },
            });
          }
          resolve({
            code: 101,
            message: '無法取得此建案',
            progress: {
              id: progressId,
            },
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
